const WHATSAPP = {
  HEADING_TITLE: 'Connect Raychat to WhatsApp',
  HEADING_SUBTITLE:
    "By connecting Raychat to WhatsApp, you can immediately respond to all your customers' chats on social networks and websites.",
  GUIDE_TITLE: 'To send and receive messages, please read the following guide.',
  STEP_ONE_TITLE: 'First stage',
  STEP_ONE_DESCRIPTION:
    'On this page, select the website you want to connect to WhatsApp in the left box section on this page. By choosing this option, a QR code will appear for you.',
  STEP_TWO_TITLE: 'Second step: (settings in WhatsApp mobile phone)',
  STEP_TWO_DESCRIPTION:
    'After selecting the website and displaying the QR image on the page, you must link your WhatsApp number to this account through your mobile phone (the WhatsApp number you want to provide to the customer)',
  STEPS_FOLLOW_DESCRIPTION:
    'You need to do the following steps on your mobile phone',
  STEPS_FOLLOW_ITEM_1:
    'Enter the WhatsApp program and click on the three dots.',
  STEPS_FOLLOW_ITEM_2: 'Enter the Linked Device section.',
  STEPS_FOLLOW_ITEM_3:
    'In this section, tap on the green button of the Link A Device option.',
  STEPS_FOLLOW_ITEM_4:
    "Scan the barcode displayed on the dashboard of your Richet with your phone's camera.",
  AFTER_STEPS_MSG:
    'Doing these steps will activate your WhatsApp connection with Raychat after a few minutes, and you can use your service.',
  WEBSITE_NOT_CHOSEN_MSG:
    'For connecting to whatsapp please choose one of the websites',
  SCAN_RETRY_BTN_LABEL: 'Retry scan',
  LOGOUT_BTN_LABEL: 'Log out',
  UPGRADE_TO_PREMIUM_MSG:
    'To use this feature please upgrade your package to premium',
};

export default WHATSAPP;
